import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

interface ErrorBoundaryWrapperProps {
  fallback: React.ReactNode;
  children: React.ReactNode;
  onError?: (error: Error, errorInfo: React.ErrorInfo) => void;
  onReset?: () => void;
}

const ErrorBoundaryWrapper: React.FC<ErrorBoundaryWrapperProps> = props => {
  // Use type assertion to bypass the ReactNode compatibility issue
  const ErrorBoundaryComponent = ReactErrorBoundary as any;

  return <ErrorBoundaryComponent {...props} />;
};

export default ErrorBoundaryWrapper;
